import React, { useRef, useEffect, forwardRef, useState } from "react";
import { AiOutlineRight } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import classes from "./MenuItem.module.css";
import { decideMenuIcon } from "../../helpers/decideIcon";
import DeleteAccountModal from "../../modals/DeleteAccountModal";
const predictSvgOrClass = (icon) => {
  return icon?.startsWith("custom") ? decideMenuIcon(icon) : <i
    className={`${icon?.iconCssClass} iconClass`}
    style={{ color: "var(--black-color)" }}
  />
};
const MenuItem = forwardRef(
  (
    {
      index,
      text,
      icon,
      path,
      listOfOptions = [],
      setIsSidebarClose,
      activeHandler,
      isActive,
      setIsSidebarOpen,
      isSidebarClose,
      isClickOnToggle,
      isParent,
    },
    ref
  ) => {
    const navigate = useNavigate();
    const location = useLocation()?.pathname.split("/")[1];
    const menuItem = useRef(null);
    const itemRef = useRef(null);
    const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false)

    const handleFunction = (id) => {
      // if (window.innerWidth <= 992) {
      //   setIsSidebarClose(true);
      // }
      if (listOfOptions?.length <= 0) {

        if (path == "deleteAccount") {
          setShowDeleteAccountModal(true);
          return;
        }
        navigate(path);
        if (isParent) {
          activeHandler(id);
        }
      }
      else {
        activeHandler(id);
      }
    };
    const handleMouseEnter = (e) => {
      if (!isClickOnToggle) {
        if (ref?.current?.offsetWidth == 58) {
          setIsSidebarClose(false);
        }
      }
    };

    return (
      <>
        <li
          ref={menuItem}
          onMouseEnter={handleMouseEnter}
          onClick={() => {
            // setIsSidebarClose(false);
          }}
        >
          <div
            ref={itemRef}
            className={[
              classes["menuItem"],
              classes["overflow-x-hidden"],
              // (text === "Dashboard" ? classes.activeMenu : location) &&
              ((location === path && !listOfOptions?.length > 0) || isActive) &&
              classes.activeMenu,
            ].join(" ")}
            onClick={() => handleFunction(index)}
          >
            <div
              className={[
                classes["menuContent"],
                classes["overflow-x-hidden"],
              ].join(" ")}
            >
              {icon ? (
                <div className={classes["menuIcon-wrapper"]}>{icon}</div>
              ) : (
                <span className={classes["circle-indicator"]} />
              )}
              <p className={classes["menu-name"]}>{text}</p>
            </div>

            {listOfOptions?.length > 0 && (
              <span className={classes["menuIndicator"]}>
                <AiOutlineRight
                  className={`mr-2 ${isActive && classes["arrowDown"]}`}
                />
              </span>
            )}
          </div>

          <div
          >
            <div
              className={`${classes["list-wrapper"]} ${isActive && listOfOptions?.length > 0 && classes["nested-option"]
                } `}
            >
              <ul className={classes["transition-effect"]}>
                {listOfOptions?.map((item, indx) => (
                  <MenuItem
                    key={indx}
                    index={indx}
                    path={item.router}
                    text={item.name}
                    listOfOptions={item.subModules}
                    setIsSidebarClose={setIsSidebarClose}
                    icon={decideMenuIcon(item?.iconCssClass)}
                    activeHandler={activeHandler}
                    isParent={item?.parentApplicationAccessId === null}
                  />
                ))}
              </ul>
            </div>
          </div>
        </li>
        {
          showDeleteAccountModal && <DeleteAccountModal show={showDeleteAccountModal} setShow={setShowDeleteAccountModal} />

        }

      </>
    );
  }
);
export default MenuItem;





// import React, { forwardRef, useRef, useState } from "react";
// import { useDispatch } from "react-redux";
// import { useLocation, useNavigate } from "react-router-dom";
// import classes from "./MenuItem.module.css";

// const MenuItem = forwardRef(
//   (
//     {
//       text,
//       icon,
//       path,
//       listOfOptions = [],
//       className,
//       active,
//       setMarkAsActive,
//     },
//     ref
//   ) => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const location = useLocation()?.pathname.split("/")[1];
//     const menuItem = useRef(null);
//     const itemRef = useRef(null);
//     const handleActive = () => {
//       if (listOfOptions === null || listOfOptions?.length <= 0) {
//         navigate(path);
//         setMarkAsActive();
//       }
//     };

//     return (
//       <>
//         <li ref={menuItem} className={[className].join(" ")}>
//           <div
//             ref={itemRef}
//             className={[
//               classes["menuItem"],
//               classes["overflow-x-hidden"],
//               (text === "Dashboard" ? classes.activeMenu : location) &&
//                 (active || location === path) &&
//                 classes.activeMenu,
//             ].join(" ")}
//             onClick={handleActive}
//           >
//             <div
//               className={[
//                 classes["menuContent"],
//                 classes["overflow-x-hidden"],
//                 (text === "Dashboard" ? classes.activeMenu : location) &&
//                   (active || location === path) &&
//                   classes.activeMenu,
//               ].join(" ")}
//             >
//               {icon ? (
//                 <div className={classes["menuIcon-wrapper"]}>{icon}</div>
//               ) : (
//                 <span className={classes["circle-indicator"]} />
//               )}
//               {text && <p className={classes["menu-name"]}>{text}</p>}
//             </div>
//           </div>
//         </li>
//       </>
//     );
//   }
// );
// export default MenuItem;
